import { connect } from "react-redux";
import TestScreen from "../components/TestScreen";
import "./ExamPage.css";
import usePreventUnload from "../../../../shared/hooks/usePreventUnload";
import LoaderPopUp from "../../../loader/loader";

const ExamPage = ({ loader }) => {
  const alertMessage = "You cannot leave this page during the exam!";
  usePreventUnload(alertMessage);

  return (
    <div className="exam_page_wrapper">
      <TestScreen />
      {loader && <LoaderPopUp />}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    loader: state.ui.loader,
  };
};

export default connect(mapStateToProps)(ExamPage);
